// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__8lXEs","slider":"Switch_slider__LXQ7m"};